type Props = {
  /** Plain-English explanation shown on hover. */
  text: string;
  /** Accessible label for the icon; defaults to a generic phrasing. */
  label?: string;
};

/**
 * A small info icon that reveals a plain-English definition on hover.
 * Uses a native `title` tooltip — the same lightweight pattern used elsewhere
 * in the dashboard (LocationAddress, ScorecardTable, ContextPicker).
 */
export default function InfoHint({ text, label = 'More info' }: Props) {
  return (
    <span className="info-hint" title={text} role="img" aria-label={`${label}: ${text}`}>
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
        <path
          d="M12 11v5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <circle cx="12" cy="7.5" r="1.25" fill="currentColor" />
      </svg>
    </span>
  );
}
